import * as React from "react"
import { Volume } from "../custom-player.styled"
import { playerPropsSelector } from "../../../../recoil/atoms/player"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { PlayerVolumeProps } from "../custom-player.interface"
import { SDKContext } from "../../../../context/SDKContext"

export const _PlayerVolume: React.FC<PlayerVolumeProps> = ({
  isControlVolume,
  watchPartyHostId,
  isVolumeScale,
  localUserId,
  value,
  handleOnMouseMove
}): JSX.Element => {
  const meetingClient = React.useContext(SDKContext)
  const roomStyles = useRecoilValue(brandingSelector)
  const setPlayerProps = useSetRecoilState(playerPropsSelector)

  const toggleControlVolume = () => {
    meetingClient?.rtc?.toggleControlVolume(false)
  }

  return (
    <>
      {isVolumeScale &&
        (watchPartyHostId === localUserId ||
          watchPartyHostId === "modNotPresentVideo") && (
          <Volume
            id="custom-player-volume"
            type="range"
            defaultValue={"70"}
            onClick={e => e.stopPropagation()}
            onMouseMove={handleOnMouseMove}
            roomStyles={roomStyles}
          />
        )}
      {isVolumeScale &&
        watchPartyHostId !== "modNotPresentVideo" &&
        watchPartyHostId !== localUserId &&
        !isControlVolume && (
          <Volume
            id="custom-player-volume"
            type="range"
            value={value}
            onClick={e => {
              toggleControlVolume()
              e.stopPropagation()
              setPlayerProps({ isControlVolume: true })
            }}
            onChange={handleOnMouseMove}
            roomStyles={roomStyles}
          />
        )}
      {isVolumeScale &&
        watchPartyHostId !== localUserId &&
        watchPartyHostId !== "modNotPresentVideo" &&
        isControlVolume && (
          <Volume
            id="custom-player-volume"
            type="range"
            defaultValue={value}
            onClick={e => {
              toggleControlVolume()
              e.stopPropagation()
            }}
            onMouseMove={handleOnMouseMove}
            roomStyles={roomStyles}
          />
        )}
    </>
  )
}

export const PlayerVolume = React.memo(_PlayerVolume)
